import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as auth from '../services/auth.js';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await auth.forgotPassword(email.trim().toLowerCase());
      navigate(`/reset-password?email=${encodeURIComponent(email.trim().toLowerCase())}`);
    } catch (err) {
      setError(err.message || 'Could not start password reset.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="container narrow">
      <section className="rise">
        <h1 className="display">Forgot your <em>password?</em></h1>
        <p className="lede">We'll mail a recovery code to the address on file.</p>

        <form onSubmit={onSubmit} className="card stack">
          <label className="field">
            <span className="field-label">Email</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          {error && <p className="error">{error}</p>}

          <div className="row between">
            <Link to="/signin" className="muted-link">Back to sign in</Link>
            <button type="submit" className="btn btn-primary" disabled={loading || !email}>
              {loading ? 'Sending…' : 'Send code'}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
}
